module.exports = "/_next/static/images/apple-duotone-a0812b2e7617899c66848999b5cc8d6c.svg";